import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import HelpPage from '@/components/HelpPage'
import CategoryDetail from '@/components/CategoryDetail'
import KolBoardPage from '@/page/KolBoardPage'
import KOLUpComing from '@/page/KOLUpComing'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/web-loops/loops-faqs/',
  routes: [
    {
      path: '/',
      name: 'HelpPage',
      component: HelpPage
    },
    {
      path: '/index',
      name: 'HelpPage',
      component: HelpPage
    },
    {
      path: '/categorydetail',
      name: 'CategoryDetail',
      component: CategoryDetail
    },
    {
      path: '/kolboard',
      name: 'KolBoardPage',
      component: KolBoardPage
    },
    {
      path: '/kolupcoming',
      name: 'KOLUpComing',
      component: KOLUpComing
    },
    {path: "*", redirect: "/"}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js